<template>

  <div v-if="!overview" class="p-fluid report-field">
    <div v-if="guide.label" class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
    <div v-for="(children) in guide.childrens" :key="children.c_key" style="margin-bottom: .3rem;">
      
      <InputText v-if="children.c_type==='text'" type="text" 
          v-model="values[children.c_key]" 
          :placeholder="$t('report.'+section+'.'+children.c_key)"
          @input="dataChanged(children, $event.target.value)"  
          :disabled="guide.disabled"
          :class="{'p-invalid':children.invalid}" :aria-label="$t('report.'+section+'.'+children.c_key)"/>
      
      <InputNumber v-if="children.c_type==='number'" 
          v-model="values[children.c_key]" 
          :placeholder="$t('report.'+section+'.'+children.c_key)"
          @input="dataChanged(children, $event.value)"  
          :disabled="guide.disabled"
          :class="{'p-invalid':children.invalid}"
          :minFractionDigits="getDecimals(children.suffix)" :maxFractionDigits="getDecimals(children.suffix)"
          :suffix="children.suffix ? ' '+getSuffix(children.suffix) : null"
          :locale="$i18n.locale"  :aria-label="$t('report.'+section+'.'+children.c_key)"
          />

      <Dropdown v-if="children.c_type==='select'" 
          v-model="values[children.c_key]" :options="domains[children.c_domain]" optionLabel="name" optionValue="code"
          :placeholder="$t('report.'+section+'.'+children.c_key)"
          @change="dataChanged(children, $event.value)" 
          :disabled="guide.disabled" 
          :class="{'p-invalid':children.invalid}"  :aria-label="$t('report.'+section+'.'+children.c_key)"/>

      <MultiSelect v-if="children.c_type==='multiselect'" 
          v-model="values[children.c_key]" :options="domains[children.c_domain]" optionLabel="name" optionValue="code"
          :placeholder="$t('report.'+section+'.'+children.c_key)"
          @change="dataChanged(children, $event.value)"  
          :disabled="guide.disabled"
          :class="{'p-invalid':children.invalid}"  :aria-label="$t('report.'+section+'.'+children.c_key)"/>

    </div>
  </div>

  <div v-else class="p-fluid report-field">
    <div v-if="guide.label" class="p-grid report-field-header">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
    <div v-for="(children) in guide.childrens" :key="children.c_key" style="margin-bottom: .3rem;">
      
      <span v-if="children.c_type==='text'" >
        {{ data[children.c_key] ?? '-' }}
      </span>
      
      <span v-if="children.c_type==='number'" >
        {{ data[children.c_key] ? data[children.c_key] : '-' }}
      </span>
      
      <span v-if="children.c_type==='select'" >
        {{ data[children.c_key] ? data[children.c_key].value : '-' }}
      </span>
      
      <span v-if="children.c_type==='multiselect'" >
        {{ data[children.c_key] ? data[children.c_key].map(u => u.value).join(', ') : '-' }}
      </span>

    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      domains: Object,
      extras: Object,
      overview: Boolean
    },
  data() {
    return {
      values: {}
    }
  },
  computed: {
  },
  created() {
    for(let children of this.guide.childrens) {
      if(children.c_type === 'text') {
        this.values[children.c_key] = this.data[children.c_key];
      } else if(children.c_type === 'number') {
        this.values[children.c_key] = this.data[children.c_key];
        try {
          let val = this.data[children.c_key] ? this.data[children.c_key].split(" ") : null;
          this.values[children.c_key] = val ? Number(val[0]) : null;
        } catch(err) {
          console.error("ERROR DECODING OF "+children.c_key+": "+this.data[children.c_key]);
          this.values[children.c_key] = null;
        }
      } else if(children.c_type === 'select') {
        this.values[children.c_key] = null;
        if(this.data[children.c_key]!=null) {
          this.values[children.c_key] = this.data[children.c_key].code;
        }
      } else if(children.c_type === 'multiselect') {
        this.values[children.c_key] = [];
        if(this.data[children.c_key]!=null) {
          for(let o of this.data[children.c_key]) {
            this.values[children.c_key].push(o.code);
          }
        }
      }
    }
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(children, newValue) {
      console.log("THIS VALUE "+this.values[children.c_key]);
      console.log("NEW VALUE "+newValue);
      if(children.c_type==='text') {
        this.$emit("update:data", { key: children.c_key, value: newValue });
      } else if(children.c_type==='number') {
        this.values[children.c_key] = newValue;
        this.$emit("update:data", { key: children.c_key, value: newValue!=null ? newValue+" "+this.getSuffix(children.suffix) : null });
      } else if(children.c_type==='select') {
        this.$emit("update:data", { key: children.c_key, value: {
            code: newValue,
            value: this.$t('report.domains.'+children.c_domain+"."+newValue)
          } });
      } else if(children.c_type ==='multiselect') {
        let valuesArray = [];
        for(let v of newValue) {
          valuesArray.push({
            code: v,
            value: this.$t('report.domains.'+children.c_domain+"."+v)
          })
        }
        this.$emit("update:data", { key: children.c_key, value: valuesArray });
      }
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        for(let key in this.values) {
          this.values[key] = null;
        }
      }
    },
    getSuffix(suffix) {
      return this.$functions.unit( suffix , this.extras.imperial );
    },
    getDecimals(suffix) {
      if(suffix!=null) {
        return this.$functions.unitDecimals(suffix);
      }
      return 0;
    }
    
  }
}
</script>

<style scoped>

</style>